module.exports = function (bh) {
    bh.match('alphabet__li', function (ctx, json) {
        ctx.tag('li');
    });
};
